import { Box } from '@mui/material';
import { GoogleMap, MarkerF } from '@react-google-maps/api';
import React from 'react';
import Address from '../../models/Address';
import { asFloat } from '../../services/ValueChecker';

interface LegacyPropertyCardAddressMapProps {
  address: Address;
}

export default function LegacyPropertyCardAddressMap({
  address,
}: LegacyPropertyCardAddressMapProps) {
  const lat = asFloat(address.latitude);
  const lng = asFloat(address.longitude);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        zIndex: 1,
      }}
    >
      <GoogleMap
        mapContainerStyle={{
          width: '100%',
          height: '300px',
          border: 'none',
        }}
        center={{ lat, lng }}
        zoom={15}
      >
        <MarkerF position={{ lat, lng }} onLoad={() => console.log('Marker loaded!')} />
      </GoogleMap>
    </Box>
  );
}
